export default (str) => {
  return str
    .replace(/_id$/, '')
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .replace(/^\w/g, function (s) {
      return s.toUpperCase();
    });
};
